<template>
  <div class="smartcard">
    <b-button
      variant="info"
      block
      @click="scanReaderDataMOI"
      style="line-height: 0.7"
      v-b-tooltip.hover
      title="สแกนบัตรประชาชนด้วย โปรแกรม MOI"
    >
      <span class="small-text">สแกน MOI</span>
    </b-button>
    <Loading v-if="isLoading"></Loading>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Loading from "@/components/Loading";

export default {
  name: "SmartCard",
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      baseURL: "http://localhost:3000",
      path: "/moi/getCardData",
      readerMessage: null,
      readerData: null,
      mockData: {
        readerName: "Generic EMV Smartcard Reader 0",
        responseCode: "0",
        responseDesc: "SCAPI SUCCESS",
        pid: "3520300051719",
        cid: "51752509111f9872",
        chipId: "40906164",
        fullNameTH: "น.ส. นวรัตน์  วัทธศิลป์",
        fullNameEN: "Miss Nawarat  Wattasin",
        birthTH: "17 ก.ค. 2516",
        birthEN: "17 Jul 1973",
        sex: "หญิง",
        cardId: "10044179880",
        sourceData: "ท้องถิ่นเขตบางรัก/กรุงเทพมหานคร",
        issueCode: "3120200191911",
        dateIssueTH: "15 ธ.ค. 2558",
        dateIssueEN: "15 Dec 2015",
        dateExpTH: "16 ก.ค. 2567",
        dateExpEN: "16 Jul 2024",
        address:
          "40/559    ถนนไทยรามัญ แขวงสามวาตะวันตก เขตคลองสามวา กรุงเทพมหานคร",
        image:
          "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",
        imageNo: "10040212151128",
        cardVersion: "0003",
        customerPid: null,
        customerCid: null,
        ktbKeyY: null,
        customerKeyY: null
      }
    };
  },
  mounted() {},
  destroyed() {},
  created() {},
  methods: {
    async scanReaderDataMOI() {
      try {
        this.isLoading = true;
        const tempApi = axios.create();
        const { data } = await tempApi.get(this.baseURL + this.path, {
          withCredentials: false
        });

        if (data.responseCode !== "0") {
          this.$emit("showDialogToast", "warning", data.responseDesc);
        } else {
          const mappedData = this.mapData(data);
          this.$emit("getReaderData", mappedData);
        }
      } catch (err) {
        console.error(err);
        this.$emit(
          "showDialogToast",
          "warning",
          `ไม่สามารถอ่านบัตรประชาชนได้
          ${err.response?.data?.message}`
        );
      } finally {
        this.isLoading = false;
      }
    },
    mapData(data) {
      const nameTh = this.splitName(data?.fullNameTH);
      const nameEn = this.splitName(data?.fullNameEN);
      const { addrProvince, addrAmphur, addrTambol, addrHouseNo } =
        this.splitAddress(data.address);
      return {
        Citizenid: data.pid,
        Th_Prefix: nameTh?.prefix,
        Th_Firstname: nameTh?.firstName,
        Th_Lastname: nameTh?.lastName,
        En_Prefix: nameEn?.prefix,
        En_Firstname: nameEn?.firstName,
        En_Lastname: nameEn?.lastName,
        gender:
          data.gender == "1" ? "ชาย" : data.gender == "2" ? "หญิง" : "อื่นๆ",
        Birthday: this.convertThaiDateWithMoment(data.birthTH),
        addrProvince,
        addrAmphur,
        addrTambol,
        addrHouseNo,
        PhotoRaw: data.image
      };
    },
    splitName(fullName) {
      // แยกชื่อเต็มโดยใช้ช่องว่างเป็นตัวแบ่ง
      const nameParts = fullName.trim().split(/\s+/);

      if (nameParts.length < 3) {
        throw new Error("ชื่อเต็มไม่ถูกต้อง");
      }

      // คำนำหน้า ชื่อ และนามสกุล
      const prefix = nameParts[0];
      const firstName = nameParts[1];
      const lastName = nameParts.slice(2).join(" ");

      return {
        prefix,
        firstName,
        lastName
      };
    },
    convertThaiDateWithMoment(thaiDate) {
      // ตั้งค่า moment ให้ใช้ locale ภาษาไทย
      moment.locale("th");

      // แปลงวันที่จากปีพุทธศักราชเป็นคริสต์ศักราช
      const date = moment(thaiDate, "DD MMM YYYY");
      const yearCE = date.year() - 543;

      // แปลงปีพุทธศักราชเป็นคริสต์ศักราช
      date.year(yearCE);

      // แปลงให้อยู่ในรูปแบบ YYYY-MM-DD
      return date.format("YYYY-MM-DD");
    },
    splitAddress(fullAddress) {
      // แยกที่อยู่ด้วยช่องว่างและหาคำสำคัญ
      const addressParts = fullAddress.split(" ");

      // คำสำคัญต่างๆ สำหรับการตรวจจับ
      const subdistrictKeys = ["แขวง", "ตำบล"];
      const districtKeys = ["เขต", "อำเภอ"];

      const subdistrictIndex = addressParts.findIndex(part =>
        subdistrictKeys.some(key => part.startsWith(key))
      );
      const districtIndex = addressParts.findIndex(part =>
        districtKeys.some(key => part.startsWith(key))
      );
      const provinceIndex = addressParts.length - 1; // จังหวัดจะเป็นส่วนสุดท้าย

      if (
        subdistrictIndex === -1 ||
        districtIndex === -1 ||
        provinceIndex === -1
      ) {
        throw new Error("ที่อยู่ไม่ถูกต้อง");
      }

      const street = addressParts.slice(0, subdistrictIndex).join(" ");
      const subdistrict = addressParts
        .slice(subdistrictIndex, subdistrictIndex + 1)
        .join(" ");
      const district = addressParts
        .slice(districtIndex, districtIndex + 1)
        .join(" ");
      const province = addressParts.slice(provinceIndex).join(" ");

      return {
        addrHouseNo: street,
        addrTambol: subdistrict,
        addrAmphur: district,
        addrProvince: province
      };
    }
  }
};
</script>
